import React from 'react';
import styles from './CookieAgreement.module.scss';
import Button from "../button/Button";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {emptyFn} from "../../../shared";

export const CookieAgreement = (props) => {
  const {className, onAgreementCookie} = props;

  return (
    <div className={clsx(styles.container, className)}>
       <p className={styles.title}>tu privacidad es importante para nosotros</p>
       <div className={clsx(styles.content, 'd-flex justify-content-between')}>
          <div>
            Nosotros y nuestros socios utilizamos tecnologías como las cookies y procesamos datos personales para personalizar los anuncios y el contenido según sus intereses. Haga clic en "Acepto" para autorizar el uso de esta tecnología y el procesamiento de sus datos personales para estos fines.
          </div>
         <Button label="Acepto" onClick={onAgreementCookie} className={styles.btn}/>
       </div>
    </div>
  );
};

CookieAgreement.propTypes = {
  className: PropTypes.string,
  onAgreementCookie: PropTypes.func
}

CookieAgreement.defaultProps = {
  onAgreementCookie: emptyFn()
}

export default CookieAgreement;